@if (!isMobileBreakpoint) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-text
        [title]="'Maintenance'" />
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Filter'"
        [image]="'assets/img/filter-white.svg'"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerDisabled]="showAboutThisPage"
        [matMenuTriggerData]="{closeDisabled: true}" />
      <tidy-small-button
        [text]="'Recurring'"
        [image]="'assets/img/recurring.svg'"
        (buttonClick)="goToRecurringTasks()" />
      <tidy-small-button
        [text]="'Archived'"
        [image]="'assets/img/archive.svg'"
        (buttonClick)="goToArchivedTasks()" />
      <tidy-small-button
        [text]="'Add Maintenance'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="addIssue.emit()" />
      <tidy-image
        [src]="'assets/img/download_csv.svg'"
        class="desktop-header-icon secondary-text-icon"
        (action)="exportCSV.emit()"/>
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase | translate }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
    <div class="non-wrappable-right-aligned-container">
      @if (showLoadingSpinner) {
        <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
      }
      <automations-preview-button
        [tag]="'maintenance'" />
    </div>
  </tidy-desktop-header>
}

@if (isMobileBreakpoint) {
  <div class="mobile-filter-row" style="display: flex; gap: 10px; align-items: center;">
    <form [formGroup]="form" novalidate action="#" style="flex: 1; min-width: 0;">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
    <tidy-small-button
      [image]="'assets/img/filter-white.svg'"
      [matMenuTriggerFor]="menu"
      [matMenuTriggerDisabled]="showAboutThisPage"
      [matMenuTriggerData]="{closeDisabled: true}"
      [iconOnly]="true"/>
    <tidy-small-button
      [text]="'Recurring'"
      [image]="'assets/img/recurring.svg'"
      (buttonClick)="goToRecurringTasks()" />
  </div>
  @if (chips?.length) {
    <div class="mobile-filter-chips">
      @for (chip of chips; track chip) {
        <ion-chip class="filter-chip">
          @if (chip.icon) {
            <mat-icon
              class="chip-icon"
              [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
          }
          <ion-label>{{ chip.name | titlecase | translate }}</ion-label>
          <ion-icon name="close-circle" (click)="removeChip(chip)" />
        </ion-chip>
      }
    </div>
  }
}

<mat-menu #menu="matMenu" class="filter-menu">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkNode(node, $event)">
          {{ node.name | titlecase | translate }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name | titlecase | translate }}
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-menu>
